import { IconButton, Stack, Typography, Container } from "@mui/material";
import { FC } from "react";
import { WebShopIcon } from "../../WebShopIcon";
import { HeaderAlertProps } from "../lib/type";

export const HeaderAlert: FC<HeaderAlertProps> = ({ title, onClose }) => {
    return (
        <Stack className={"bg-super-light-gray py-3 px-5 gap-4 max-sm:gap-3-"}>
            <Container className={"flex-center-row justify-between"}>
                <Typography component={"h2"} className={"flex-grow-[0.9] justify-center text-[14px]"}>
                    {title}
                </Typography>
                <IconButton onClick={onClose}>
                    <WebShopIcon name={"close"} className="w-4 h-4 fill-dark-gray" />
                </IconButton>
            </Container>
        </Stack>
    );
};
